import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import ErrorBoundary from './ErrorBoundary';

const Layout: React.FC = () => {
  return (
    <div className="layout">
      <Navbar />
      <main className="main-content">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-section footer-brand-section">
              <h4 className="footer-heading">Patriot Academy Premium</h4>
              <p className="footer-tagline">The Microsoft Security Partner</p>
              <p className="footer-text">
                Expert-led Microsoft Security training for professionals and teams.
              </p>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Mailing Address</h4>
              <p className="footer-text">
                17192 Murphy Avenue #14067,<br />
                Irvine, CA 92623-4067
              </p>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Contact</h4>
              <ul className="footer-list">
                <li>
                  <span className="footer-label">Phone:</span>{' '}
                  <a href="tel:1-844-560-4630">1-844-560-4630</a>
                </li>
                <li>
                  <span className="footer-label">Email:</span>{' '}
                  <a href="mailto:training@patriotconsulting.com">training@patriotconsulting.com</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-list">
                <li><Link to="/courses">Course Catalog</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><a href="https://patriotconsulting.com" target="_blank" rel="noopener noreferrer">About Patriot Consulting</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Patriot Consulting Technology. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
